import React from 'react';
import { Icon } from '../../../shared/utils/icons';

// The three standing invitations, shown to every visitor (unlike MySessions, which
// needs registrations). Ordered by what the reader can act on soonest: joining a
// chapter is one click, sponsoring is a conversation.
const ForumActions = ({ chapters = [], links = {} }) => (
    <div className="sidebar-panel">
        <section className="sidebar-block">
            <h3 className="sidebar-block__title">
                <Icon name="globe" size={42} strokeWidth={1} />
                Join a Chapter
            </h3>
            <p>
                Connect with the Forum community in your region and take part in upcoming chapter
                sessions and activities.
            </p>
            {/* Every chapter, in the server's A-Z order, across two columns — the whole
                network fits, so there is nothing left for a "view all" to reveal. */}
            <ul className="chapter-links">
                {chapters.map((chapter) => (
                    <li key={chapter.slug}>
                        <a href={chapter.url}>{chapter.name}</a>
                    </li>
                ))}
            </ul>
        </section>

        <section className="sidebar-block">
            <h3 className="sidebar-block__title">
                <Icon name="briefcase" size={42} strokeWidth={1} />
                Sponsor an Event
            </h3>
            <p>
                Connect your organization with legal operations and in-house legal professionals
                through a regional or Global Forum session.
            </p>
            <a className="sidebar-block__link" href={links.sponsor}>
                Explore Sponsorship
                <Icon name="arrow" size={17} strokeWidth={2} />
            </a>
        </section>

        <section className="sidebar-block">
            <h3 className="sidebar-block__title">
                <Icon name="user-plus" size={42} strokeWidth={1} />
                Get Involved
            </h3>
            <p>
                Help shape the Legal Operations &amp; KPIs Forum in your region. Contribute to an
                existing chapter or help us grow the community.
            </p>
            <a className="sidebar-block__link" href={links.getInvolved}>
                Share Your Interest
                <Icon name="arrow" size={17} strokeWidth={2} />
            </a>
        </section>
    </div>
);

export default ForumActions;
